import { motion } from "framer-motion";
import { CDN } from "../data";

export const About = () => (
  <section id="about" className="section" data-testid="about-section">
    <div className="about-grid">
      <motion.img
        className="about-photo"
        src={CDN + "hf_20260830_193346_8d0dd934-0cdc-4a3f-86c7-613ad6174ec0_min.webp"}
        alt="Lucho Gomez Connect work truck on a ridge overlooking a Kaua'i valley at golden hour"
        loading="lazy"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
      />
      <motion.div className="about-col" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8, delay: 0.15 }}>
        <p className="eyebrow">Your Kaua'i property care contact</p>
        <p className="quote">"Big job or small job, I treat every property like my own."</p>
        <p className="body">Lucho Gomez lives and works on Kaua'i, helping homeowners, landowners and off-island clients take care of what matters most: your property, your animals, your peace of mind.</p>
        <p className="body">Clear communication, honest quotes and respect for your land. When a job calls for a specialist, he brings in trusted local connections for painting, building, heavy tree removal and more. If he can't do it, he knows someone who can.</p>
        <p className="body">Nina, the shop dog, approves every finished yard.</p>
        <img className="hibiscus" src={CDN + "hf_20260830_191449_f479e087-54a3-4486-950b-d8e42f7e9e3d_min.webp"} alt="Red hibiscus flower, a symbol of Hawaii" loading="lazy" />
      </motion.div>
    </div>
    <div className="creds">
      <span className="cred"><b>Licensed &amp; insured</b></span>
      <span className="cred"><b>Luciano Gomez Consulting LLC</b>, registered in Hawaii</span>
      <span className="cred">Serving <b>all of Kaua'i</b>, Lihu'e &amp; Kapa'a based</span>
      <span className="cred"><b>Nina approved</b></span>
    </div>
  </section>
);
